import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ANUENCIA.BUSCAR_DADOS_CABECALHO](context, idControleAnuencia) {
		let { data } = await api.anuencia.buscarDadosCabecalho(idControleAnuencia)

		return data
	},
	async [actionTypes.ANUENCIA.FINALIZAR](context, idControleAnuencia) {
		await api.anuencia.finalizarAnuencia(idControleAnuencia)
	},
}
